import { Center, Text } from "@mantine/core";
import { useLanguage } from "../../../stores/LanguageStore";

const NoRowsDisplay = ({ component }) => {
  const lang = useLanguage(s => s.language)
  return (
    <Center h={"100%"}>
      {component || (
        <Text>{lang.table.no_data}</Text>
      )}
    </Center>
  );
};

export default NoRowsDisplay;
